module.exports = __webpack_public_path__ + "static/media/sqrl.3e82acb6.png";